import IDate from './date';

interface IRange {
  bookmarks?: {
    start?: number;
    end?: number;
  };
  event?: IDate;
  seek?: IDate;
}

interface ITrack {
  language: string;
  id: string;
}

interface ITracks {
  audio: ITrack[];
  subtitles: ITrack[];
}

enum TrackType {
  AUDIO = 'audio',
  SUBTITLES = 'subtitles',
}

export { TrackType };
export type { IRange, ITrack, ITracks };
